module.exports = require('../src/client').client;